import { render, staticRenderFns } from "./EmptyRecord.vue?vue&type=template&id=378c8375&scoped=true"
import script from "./EmptyRecord.vue?vue&type=script&lang=js"
export * from "./EmptyRecord.vue?vue&type=script&lang=js"
import style0 from "./EmptyRecord.vue?vue&type=style&index=0&id=378c8375&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378c8375",
  null
  
)

export default component.exports